<template>
  <div>
    <el-breadcrumb separator="/" style="margin-bottom: 15px;">
      <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
    </el-breadcrumb>
    
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>菜单管理</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="showAddDialog('0')" v-permission="'btn:menu:add'">添加顶级菜单</el-button>
      </div>
      
      <el-table
        ref="menuTable"
        :data="menuList"
        style="width: 100%; min-width: 1200px"
        row-key="id"
        border
        :default-expand-all="false"
        :expand-row-keys="expandRowKeys"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        :row-class-name="tableRowClassName"
        fit>
        <!-- 菜单名称列 -->
        <el-table-column prop="name" label="菜单名称" min-width="21%" align="left" header-align="center">
          <template slot-scope="scope">
            <div class="menu-item-wrapper" :class="{'level-1-row': scope.row.parentId === 0 || scope.row.parentId === null, 'level-2-row': scope.row.parentId > 0 && scope.row.type === 1, 'level-3-row': scope.row.type === 2}">
              <div :class="{'menu-content-center': scope.row.parentId === 0 || scope.row.parentId === null, 'menu-content-left': scope.row.parentId > 0 && scope.row.type === 1, 'menu-content-left-more': scope.row.type === 2}">
                <div class="menu-content-main">
                  <span class="menu-icon-wrapper" :class="{'level-1': scope.row.parentId === 0, 'level-2': scope.row.parentId > 0 && scope.row.type === 1, 'level-3': scope.row.type === 2}">
                    <i :class="scope.row.icon"></i>
                  </span>
                  <span class="menu-name" :class="{'level-1': scope.row.parentId === 0, 'level-2': scope.row.parentId > 0 && scope.row.type === 1, 'level-3': scope.row.type === 2}">
                    {{ scope.row.name }}
                  </span>
                </div>
                <span
                  v-if="scope.row.children && scope.row.children.length > 0"
                  class="expand-click-area"
                  :class="{'expanded': isExpanded(scope.row.id)}"
                  @click.stop="handleExpandClick(scope.row)"
                >
                  <i class="el-icon-arrow-right"></i>
                </span>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- 类型标识列 -->
        <el-table-column label="类型" min-width="10%" align="center" class-name="center-content">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 1" type="primary" size="medium" effect="light">菜单</el-tag>
            <el-tag v-else-if="scope.row.type === 2" type="warning" size="medium" effect="light">按钮</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="icon" label="图标" min-width="11%" align="center" class-name="center-content">
          <template slot-scope="scope">
            <i :class="scope.row.icon"></i> {{scope.row.icon}}
          </template>
        </el-table-column>
        <el-table-column prop="path" label="路由路径" min-width="10%" align="center" class-name="center-content"></el-table-column>
        <el-table-column prop="sort" label="排序" min-width="6%" align="center" class-name="center-content"></el-table-column>
        <el-table-column label="是否隐藏" min-width="8%" align="center" class-name="center-content">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isHidden" type="info" size="medium" effect="light">隐藏</el-tag>
            <el-tag v-else type="success" size="medium" effect="light">显示</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="permissionCode" label="权限标识" min-width="12%" align="center" class-name="center-content"></el-table-column>
        <el-table-column label="操作" min-width="20%" align="center" class-name="center-content">
          <template slot-scope="scope">
            <el-button size="mini" @click="showEditDialog(scope.row)" v-permission="'btn:menu:edit'">编辑</el-button>
            <el-button size="mini" type="success" @click="showAddDialog(scope.row.id)" v-if="scope.row.type === 1" v-permission="'btn:menu:add'">添加子项</el-button>
            <el-button size="mini" type="danger" @click="deleteMenu(scope.row.id)" v-permission="'btn:menu:delete'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    
    <!-- 添加/编辑菜单对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="dialogClosed">
      <el-form :model="menuForm" :rules="menuFormRules" ref="menuFormRef" label-width="100px">
        <el-form-item label="菜单名称" prop="lbname">
          <el-input v-model="menuForm.lbname"></el-input>
        </el-form-item>
        <el-form-item label="图标" prop="icon">
          <icon-selector v-model="menuForm.icon"></icon-selector>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="menuForm.type">
            <el-radio :label="1">菜单</el-radio>
            <el-radio :label="2">按钮</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="路由路径" prop="router" v-if="menuForm.type === 1">
          <el-input v-model="menuForm.router" placeholder="例如：/users"></el-input>
        </el-form-item>
        <el-form-item label="权限标识" prop="permissionCode">
          <el-input v-model="menuForm.permissionCode" :placeholder="menuForm.type === 1 ? '例如：系统管理:菜单' : '例如：user:add'"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="orderid">
          <el-input-number v-model="menuForm.orderid" :min="1" :max="100"></el-input-number>
        </el-form-item>
        <el-form-item label="是否隐藏" prop="isHidden">
          <el-switch v-model="menuForm.isHidden" active-text="隐藏" inactive-text="显示"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import IconSelector from '../common/IconSelector.vue'

export default {
  components: {
    IconSelector
  },
  data() {
    return {
      menuList: [],
      expandRowKeys: [], // 默认展开的行
      serialNumbers: {}, // 存储一级菜单的序号
      expandedMap: {}, // 记录展开状态
      dialogVisible: false, // 对话框可见性
      dialogTitle: '添加菜单', // 对话框标题
      isEdit: false, // 是否是编辑模式
      menuForm: {
        id: null,
        lbname: '',
        icon: 'el-icon-menu',
        router: '',
        orderid: 1,
        parentId: 0,
        type: 1,
        permissionCode: '',
        isHidden: false
      },
      menuFormRules: {
        lbname: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        icon: [
          { required: true, message: '请输入图标', trigger: 'blur' }
        ],
        permissionCode: [
          { required: true, message: '请输入权限标识', trigger: 'blur' }
        ],
        orderid: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ]
      }
    }
  },
  
  created() {
    // 不要在这里调用getMenuList方法
    // 防止this.getMenuList未定义错误
    console.log('Menus组件created钩子执行');
  },
  
  mounted() {
    // 获取菜单列表
    this.getMenuList();
    
    // 添加自定义样式到head
    const style = document.createElement('style')
    style.type = 'text/css'
    style.innerHTML = '' +
      '/* 内容居中样式 */' +
      '.center-content .cell {' +
        'display: flex;' +
        'justify-content: center;' +
        'align-items: center;' +
      '}' +
      '' +
      '/* 修改菜单行的样式，确保箭头与文字对齐 */' +
      '.el-table__row .cell {' +
        'display: flex;' +
        'align-items: center;' +
      '}' +
      '' +
      '/* 将箭头移到右边，并设置为绝对定位 */' +
      '.el-table__expand-icon {' +
        'opacity: 0 !important;' +
        'pointer-events: none !important;' +
        'width: 0 !important;' +
        'height: 0 !important;' +
        'margin: 0 !important;' +
        'padding: 0 !important;' +
      '}' +
      '' +
      '/* 修改箭头图标样式 */' +
      '.el-table__expand-icon .el-icon-arrow-right {' +
        'font-weight: bold;' +
        'color: #409EFF;' +
        'font-size: 14px;' +
        'transition: all 0.3s;' +
        'position: relative;' +
        'top: 0px;' +
        'left: 0px;' +
      '}' +
      '' +
      '/* 展开状态样式 */' +
      '.el-table__expand-icon--expanded {' +
        'background-color: #ecf5ff;' +
        'border-color: #a0cfff;' +
      '}' +
      '' +
      '/* 展开状态箭头旋转 */' +
      '.el-table__expand-icon--expanded .el-icon-arrow-right {' +
        'transform: rotate(90deg);' +
      '}' +
      '' +
      '/* 确保菜单名称列的内容垂直居中 */' +
      '.el-table .el-table__row td:first-child .cell {' +
        'position: relative;' +
        'display: flex;' +
        'align-items: center;' +
        'height: 100%;' +
      '}' +
      '' +
      '/* 去除箭头左边的缩进空间 */' +
      '.el-table__indent {' +
        'padding-left: 0 !important;' +
      '}' +
      '' +
      '/* 自定义点击区域样式 */' +
      '.expand-click-area {' +
        'position: absolute;' +
        'right: 15px;' +
        'width: 24px;' +
        'height: 24px;' +
        'cursor: pointer;' +
        'z-index: 20;' +
        'border-radius: 4px;' +
        'transition: all 0.3s;' +
        'background-color: #f0f7ff;' +
        'border: 1px solid #d9ecff;' +
        'display: inline-flex;' +
        'align-items: center;' +
        'justify-content: center;' +
      '}' +
      '' +
      '.expand-click-area i {' +
        'font-size: 14px;' +
        'color: #409EFF;' +
        'font-weight: bold;' +
        'transition: all 0.3s;' +
      '}' +
      '' +
      '.expand-click-area.expanded {' +
        'background-color: #ecf5ff;' +
        'border-color: #a0cfff;' +
      '}' +
      '' +
      '.expand-click-area.expanded i {' +
        'transform: rotate(90deg);' +
      '}' +
      '' +
      '/* 自定义占位符样式 */' +
      '.expand-placeholder {' +
        'position: absolute;' +
        'right: 15px;' +
        'width: 24px;' +
        'height: 24px;' +
        'display: inline-block;' +
      '}';
  
    document.head.appendChild(style)
  },
  methods: {
    // 根据菜单层级设置行的样式
    tableRowClassName({ row }) {
      if (row.parentId === 0) {
        return 'level-1-row';
      } else if (row.type === 1) {
        return 'level-2-row';
      } else {
        return 'level-3-row';
      }
    },
    // 获取菜单列表
    async getMenuList() {
      try {
        const { data: res } = await this.$http.get('getmenulist/');
        if (res.status === 0) {
          this.menuList = this.transformMenus(res.data)
          // 设置所有一级菜单默认展开
          this.expandRowKeys = this.menuList
            .filter(item => item.parentId === 0)
            .map(item => item.id)
          
          // 初始化展开状态
          this.initExpandedState()
          
          // 初始化序号
          this.initSerialNumbers();
        } else {
          this.$message.error('获取菜单列表失败');
        }
      } catch (error) {
        console.error('获取菜单列表出错:', error);
        this.$message.error('获取菜单列表出错');
      }
    },
    
    // 初始化展开状态
    initExpandedState() {
      this.expandedMap = {}
      this.expandRowKeys.forEach(id => {
        this.expandedMap[id] = true
      })
    },
    
    // 判断是否展开
    isExpanded(id) {
      return !!this.expandedMap[id]
    },
    
    // 处理箭头点击事件
    handleExpandClick(row) {
      if (this.hasChildren(row)) {
        // 切换展开状态
        const rowKey = row.id
        // 先更新展开状态记录
        this.expandedMap[rowKey] = !this.expandedMap[rowKey]
        
        // 然后切换行的展开状态
        if (this.expandedMap[rowKey]) {
          // 如果要展开
          if (!this.expandRowKeys.includes(rowKey)) {
            this.expandRowKeys.push(rowKey)
          }
          this.$refs.menuTable.toggleRowExpansion(row, true)
        } else {
          // 如果要收起
          const index = this.expandRowKeys.indexOf(rowKey)
          if (index !== -1) {
            this.expandRowKeys.splice(index, 1)
          }
          this.$refs.menuTable.toggleRowExpansion(row, false)
        }
      }
    },
    
    // 切换展开状态
    toggleExpand(row) {
      const id = row.id
      if (this.expandedMap[id]) {
        // 如果已展开，则收起
        this.expandedMap[id] = false
        const index = this.expandRowKeys.indexOf(id)
        if (index !== -1) {
          this.expandRowKeys.splice(index, 1)
        }
      } else {
        // 如果未展开，则展开
        this.expandedMap[id] = true
        this.expandRowKeys.push(id)
      }
    },
    
    // 初始化序号
    initSerialNumbers() {
      // 重置序号对象
      this.serialNumbers = {}
      
      // 只对一级菜单设置序号
      let index = 1
      this.menuList.forEach(item => {
        if (item.parentId === 0) {
          this.serialNumbers[item.id] = index++
        }
      })
    },
    
    // 获取序号
    getSerialNumber(row) {
      return this.serialNumbers[row.id] || ''
    },
    
    // 将后端返回的层级结构转换为前端需要的树形结构
    transformMenus(menus) {
      // 排序函数：先按orderid/sort排序，再按id排序
      const sortMenus = (items) => {
        return items.sort((a, b) => {
          // 先按排序字段排序
          const sortA = a.sort || 0;
          const sortB = b.sort || 0;
          if (sortA !== sortB) {
            return sortA - sortB;
          }
          // 如果排序字段相同，再按ID排序
          return a.id - b.id;
        });
      };

      const transform = (items) => {
        // 先转换每个菜单项
        const transformedItems = items.map(item => {
          // 将后端字段名映射到前端字段名
          const menuItem = {
            id: item.id,
            lbname: item.name, // 前端显示用name，后端存储用lbname
            icon: item.icon,
            router: item.path, // 前端显示用path，后端存储用router
            orderid: item.sort, // 前端显示用sort，后端存储用orderid
            parentId: item.parentId,
            type: item.type,
            permissionCode: item.permissionCode,
            isHidden: item.isHidden, // 添加isHidden字段
            // 同时保留前端显示字段，便于表格显示
            name: item.name,
            path: item.path,
            sort: item.sort
          }
          
          // 如果有子菜单，递归转换并排序
          if (item.children && item.children.length > 0) {
            menuItem.children = transform(item.children)
          } else if (item.parentId === 0 || item.parentId === null) {
            // 保证所有一级菜单都有 children 字段
            menuItem.children = []
          }
          
          return menuItem
        })
        
        // 对同级菜单进行排序
        return sortMenus(transformedItems);
      }
      
      return transform(menus)
    },
    
    // 获取菜单层级
    getLevel(row) {
      let level = 0;
      let currentRow = row;
      
      // 递归查找父菜单层级
      const findParentLevel = (menuList, parentId) => {
        for (let menu of menuList) {
          if (menu.id === parentId) {
            level++;
            if (menu.parentId !== 0) {
              findParentLevel(this.menuList, menu.parentId);
            }
            break;
          } else if (menu.children && menu.children.length > 0) {
            const found = findParentLevel(menu.children, parentId);
            if (found) return true;
          }
        }
        return false;
      };
      
      if (currentRow.parentId !== 0) {
        level = 1;
        findParentLevel(this.menuList, currentRow.parentId);
      }
      
      return level;
    },
    
    // 检查是否有子菜单
    hasChildren(row) {
      return row.children && row.children.length > 0;
    },
    
    // 显示添加菜单对话框
    showAddDialog(parentId) {
      this.isEdit = false
      this.dialogTitle = parentId === '0' ? '添加顶级菜单' : '添加子菜单'
      this.menuForm = {
        lbname: '', // 后端存储字段名
        icon: 'el-icon-menu',
        router: '', // 后端存储字段名
        orderid: 1, // 后端存储字段名
        parentId: parseInt(parentId),
        type: 1,
        permissionCode: ''
      }
      this.dialogVisible = true
    },
    
    // 显示编辑菜单对话框
    showEditDialog(menu) {
      this.isEdit = true
      this.dialogTitle = '编辑菜单'
      this.menuForm = JSON.parse(JSON.stringify(menu)) // 深拷贝
      this.dialogVisible = true
    },
    
    // 关闭对话框
    dialogClosed() {
      this.$refs.menuFormRef.resetFields()
    },
    
    // 提交表单
    submitForm() {
      this.$refs.menuFormRef.validate(async valid => {
        if (!valid) return
        
        try {
          let res
          if (this.isEdit) {
            // 编辑菜单
            res = await this.$http.put('editmenu/', this.menuForm);
          } else {
            // 添加菜单
            res = await this.$http.post('addmenu/', this.menuForm);
          }
          
          if (res.data.status === 0) {
            this.$message.success(res.data.message);
            this.dialogVisible = false;
            this.getMenuList(); // 刷新菜单列表
          } else {
            this.$message.error(res.data.message);
          }
        } catch (error) {
          console.error('保存菜单出错:', error);
          this.$message.error('保存菜单出错');
        }
      })
    },
    
    // 删除菜单
    async deleteMenu(id) {
      try {
        // 确认删除
        const confirmResult = await this.$confirm('此操作将永久删除该菜单, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch(err => err)
        
        if (confirmResult !== 'confirm') {
          return this.$message.info('已取消删除');
        }
        
        // 执行删除
        const { data: res } = await this.$http.delete('deletemenu/' + id);
        if (res.status === 0) {
          this.$message.success(res.message);
          this.getMenuList(); // 刷新菜单列表
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.error('删除菜单出错:', error);
        this.$message.error('删除菜单出错');
      }
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.menu-item-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
}

.menu-item-wrapper.level-1-row {
  padding: 16px 0;
  background-color: #f0f7ff;
  border-bottom: 1px solid #d9ecff;
}

.menu-item-wrapper.level-2-row {
  padding: 8px 0;
  background-color: #f9fafc;
}

.menu-item-wrapper.level-3-row {
  padding: 6px 0;
  background-color: #ffffff;
}

.menu-content-center {
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 0;
  padding-right: 30px;
  width: 100%;
}
.menu-content-left {
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 30px;
  padding-right: 30px;
  width: 100%;
}
.menu-content-left-more {
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 60px;
  padding-right: 30px;
  width: 100%;
}
.menu-content-main {
  display: flex;
  align-items: center;
}
.expand-click-area {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #409EFF;
  cursor: pointer;
  transition: color 0.2s;
}
.expand-click-area.disabled {
  color: #ccc;
  cursor: not-allowed;
  pointer-events: none;
}
.expand-click-area i {
  font-size: 12px;
  width: 12px;
  height: 12px;
  display: block;
  text-align: center;
  line-height: 1;
}
.expand-click-area.expanded i {
  transform: rotate(90deg);
}

.menu-icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  margin-right: 10px;
}

.menu-icon-wrapper.level-1 {
  background-color: #409EFF;
  color: white;
  width: 32px;
  height: 32px;
  font-size: 16px;
}

.menu-icon-wrapper.level-2 {
  background-color: #67C23A;
  color: white;
  width: 24px;
  height: 24px;
}

.menu-icon-wrapper.level-3 {
  background-color: #E6A23C;
  color: white;
  width: 20px;
  height: 20px;
  font-size: 12px;
}

.menu-name {
  display: inline-block;
}

.menu-name.level-1 {
  font-weight: bold;
  font-size: 16px;
  color: #303133;
}

.menu-name.level-2 {
  font-size: 14px;
  color: #606266;
}

.menu-name.level-3 {
  font-size: 13px;
  color: #909399;
}

.bracket {
  margin-left: 10px;
  font-size: 20px;
  font-weight: bold;
  color: #409EFF;
}

/* 自定义展开箭头样式 */
.custom-expand-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-left: 15px;
  background-color: #f0f7ff;
  border-radius: 4px;
  border: 1px solid #d9ecff;
  cursor: pointer;
  transition: all 0.3s;
}

.custom-expand-icon i {
  font-size: 16px;
  color: #409EFF;
  font-weight: bold;
  transition: all 0.3s;
}

.custom-expand-icon.expanded {
  background-color: #ecf5ff;
  border-color: #a0cfff;
}

.custom-expand-icon.expanded i {
  transform: rotate(90deg);
}

/* 自定义点击区域样式 */
.expand-click-area {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #409EFF;
  cursor: pointer;
  transition: color 0.2s;
}
.expand-click-area.disabled {
  color: #ccc;
  cursor: not-allowed;
  pointer-events: none;
}
.expand-click-area.expanded i {
  transform: rotate(90deg);
}

.expand-placeholder {
  position: absolute;
  right: 15px;
  width: 24px;
  height: 24px;
  display: inline-block;
}

.el-tag--primary.el-tag--plain {
  background-color: #ecf5ff;
  border-color: #409EFF;
  color: #409EFF;
  font-weight: bold;
  font-size: 15px;
}

.el-tag--success.el-tag--plain {
  background-color: #f0f9eb;
  border-color: #67C23A;
  color: #67C23A;
  font-size: 14px;
}

.el-tag--info.el-tag--plain {
  background-color: #f4f4f5;
  border-color: #909399;
  color: #909399;
  font-size: 13px;
}

/* 表格行样式已在组件内通过class绑定实现 */

/* 三角箭头样式已移至mounted中添加 */
.expand-click-area {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #409EFF;
  cursor: pointer;
  transition: color 0.2s;
}
.expand-click-area.disabled {
  color: #ccc;
  cursor: not-allowed;
  pointer-events: none;
}
.expand-click-area.expanded i {
  transform: rotate(90deg);
}

.el-table__expand-icon,
.el-table__indent {
  display: none !important;
  width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}
</style>
